export default {
  NORMAL: "14px",
}
